import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7_supports-color@8.1.1/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@5.2.1_supports-color@8.1.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-svgrepo-com",
  "use": "icon-down-svgrepo-com-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 52\" id=\"icon-down-svgrepo-com\">\n<path d=\"M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol